import { Injector } from "@angular/core";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";
import { AuthorisedProductAutoUploadEntity } from "../Entity/AuthorisedProductAutoUploadEntity";
import { DevelopmentProductAutoUploadEntity } from "../Entity/DevelopmentProductAutoUploadEntity";
import { DummyNode } from "../../DummyNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { MedicinalproductsService } from "../../../../service/medicinalproducts-service/medicinalproducts.service";
import { environment } from "../../../../../../environments/environment";
import { BaseNode } from "../../BaseNode";
import { OnDemandAutoUploadList } from "./OnDemandAutouploadList";

export enum VersionTypeEnum {
    previous = 'lt',
    subsequent = 'gt',
}

export enum ReportingNameTypeEnum {
    presentation = 'presentationName',
    scientific = 'scientificName',
}

export function getProductVersionItems(model: any, versionType: VersionTypeEnum): any[] | undefined {
    const versionGroup = versionType === VersionTypeEnum.previous ? model.previousversions : model.subsequentversions;
    const versions = versionGroup?.version;

    if (versions === undefined || versions === null) {
        return undefined;
    }

    return Array.isArray(versions) ? versions : [versions];
}

export class TreeNodeMedicinalProductsPreviousProductVersion extends OnDemandAutoUploadList{

    evCode: any;
    revision: any;
    typeEnum: any;
    versionType: any;
    useHist: boolean = false;
    constructor(injector: Injector, evCode: string, revision:number, type:EntityEnum, versionType: VersionTypeEnum, parent: any,useHist: boolean, disableAutoupload: boolean, cloningNode: boolean, items?: any[]|undefined) {
        super(injector,
             versionType==VersionTypeEnum.previous?"Previous Versions":"Subsequent Versions",
             ["EV Code","Version","Version Status","Version Validity","Full Presentation Name"],
             ServiceEnum.MedicinalProducts,
             `ev_Code:eq:${evCode}~revision:${versionType}:${revision}`,
             type==EntityEnum.authorisedProduct?AuthorisedProductAutoUploadEntity:DevelopmentProductAutoUploadEntity,
             type,
             disableAutoupload,
             cloningNode,
             items);

             this.parent = parent;
                 if (items !== undefined) {
                     this.dataSource = items;
                     this.isLoaded = true;
                 }
             this.useHist = useHist;
             this.evCode = evCode;
             this.revision = revision;
             this.typeEnum = type;
             this.versionType = versionType;
             this.versionType == 'lt' ? this.labelNodeName = 'Previous Versions' : this.labelNodeName = 'Subsequent Versions';

             if (this.cloningNode) {
                return;
             }

                 if (items === undefined) {
                     this.children?.push(new DummyNode());
                 }
    }

    override postLoad(model: any[]) {

        for (const item of model) {

            let labelTemplate = ''; 
            if (item.type_product === 2) {
                labelTemplate = `Authorised - ${item.ev_Code} - ${item.version} - ${item.productname}`;
            } else if (item.type_product === 1) {
                labelTemplate = `Development - ${item.ev_Code} - ${item.version} - ${item.productname?item.productname:item.productcode}`;
            }            
            this.children?.push(new this.entityClass!(this.ioc, labelTemplate, this, item, false, false));
        }
        const numItems: string = model && model.length > 0?model.length.toString():'-'; 
        this.label = this.labelTemplate + ' (' + numItems + ')';
        this.refreshLabel();
    }

    override load() {

      let service: any;
        switch (this.service) {
            case ServiceEnum.MedicinalProducts:
                service = this.ioc!.get(MedicinalproductsService);
                break;
        }

        if (this.isLoaded) {
            return;
        }

        if (this.disableAutoUpload) {
            this.children?.splice(0, this.children.length); // remove dummy node
            this.data = new this.entityClass!(this.ioc!, this.labelTemplate, this, this.data.model, this.disableAutoUpload, this.cloneNode);
            if (!this.cloningNode){
                this.postLoad(this.dataSource);
            }
            this.isLoaded = true;
        } else {        
            this.children?.splice(0, this.children.length); // remove dummy node
            service.getAll(this,this.autoUploadEntityName, this.criteria)
                .subscribe({
                    next: (data: any) => {
                        const jsonData = data.result;
                        const filteredData = this.filterResult(data.result);
                        if (filteredData) {
                            this.dataSource = jsonData;
                            this.postLoad(filteredData);
                            this.isLoaded = true;
                        } else {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                        }
                    },
                    error: (error: any) => {
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                    }
                });
        }
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsPreviousProductVersion = new TreeNodeMedicinalProductsPreviousProductVersion(
        this.ioc!,
        this.evCode,
        this.revision,
        this.typeEnum,
        this.versionType,
        newParent,
        false,
        this.isLoaded,
        true
      );
      
    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
    clonedNode.dataSource = this.dataSource ? JSON.parse(JSON.stringify(this.dataSource)) : this.dataSource;
    clonedNode.isLoaded = this.isLoaded;
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
      
      clonedNode.cloningNode = false;
      return clonedNode;
    }

    override getOnDemandEntities() {
        let entitiesArray:any[] = super.getOnDemandEntities();
        // check if not empy array then set the name for JSON
        if(entitiesArray.length>0) {
            switch (this.versionType)
            {
                case VersionTypeEnum.previous:
                    return {previousversions:{version: entitiesArray} }
                case VersionTypeEnum.subsequent:
                    return {subsequentversions:{version: entitiesArray} }
            }   
            
        }
        return {};
    }

}